import React from "react";

import { RiErrorWarningFill } from "react-icons/ri";

import "./WarningMessage.css";

function WarningMessage({ message }) {
  return (
    <div className="warning-message">
      <RiErrorWarningFill size={20} />
      <p>{message}</p>
    </div>
  );
}

export default WarningMessage;
